import type { UIMessage } from 'ai'

export const getTextFromParts = (parts: UIMessage['parts']): string =>
  parts
    .filter((p) => p.type === 'text')
    .map((p) => ('text' in p ? (p.text as string) : ''))
    .join('')
